import React from 'react';
import { useStyletron } from 'baseui';
import { AdPlacementConfigViewer } from './components';

const AdsDashboardHome: React.FC = () => {
	const [css] = useStyletron();

	return (
		<div
			className={css({
				minHeight: '100vh',
				backgroundColor: '#f8f9fa'
			})}>
			<AdPlacementConfigViewer />
		</div>
	);
};

export default AdsDashboardHome;
